export default __webpack_public_path__ + "static/media/icono-volver.6becedd4.svg";